import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    template: '<mat-icon [fontSet]="fontSet" [fontIcon]="fontIcon" [matTooltip]="title" [color]="color"></mat-icon>',
    selector: 'bar-icon-cell-renderer',
    imports: [MatIconModule, MatTooltipModule]
})
/** Will render an icon in an ag-grid cell. */
export class BarIconCellRenderer implements ICellRendererAngularComp {
    protected params: ICellRendererParams;

    protected fontIcon: string;
    protected fontSet: string;
    protected title: string;
    protected color: string;

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.fontIcon = this.#defineFontIcon();
        this.fontSet = this.#defineFontSet();
        this.title = this.#defineTitle();
        this.color = this.#defineColor();
    }

    #defineFontIcon(): string {
        const fontIcon = (<any>this.params).fontIcon;
        if (fontIcon != null) {
            if (fontIcon instanceof Function) {
                return fontIcon(this.params.data);
            } else {
                return fontIcon;
            }
        }
        return null;
    }

    #defineFontSet(): string {
        const fontSet = (<any>this.params).fontSet;
        if (fontSet != null) {
            if (fontSet instanceof Function) {
                return fontSet(this.params.data);
            } else {
                return fontSet;
            }
        }
        return null;
    }

    #defineTitle(): string {
        const title = (<any>this.params).title;
        if (title != null) {
            if (title instanceof Function) {
                return title(this.params.data);
            } else {
                return title;
            }
        }
        // by default use the field content
        return this.params.data[this.params.colDef.field];
    }

    #defineColor(): string {
        const color = (<any>this.params).color;
        if (color != null) {
            if (color instanceof Function) {
                return color(this.params.data);
            } else {
                return color;
            }
        }
        return null;
    }
}
